var map = {
	"./GAME_AIRPLANE1.jpg": "d42c",
	"./GAME_AIRPLANE2.jpg": "da31",
	"./GAME_BALLOON1.jpg": "1ebd",
	"./GAME_BALLOON2.jpg": "e8be",
	"./GAME_BEAUTIFULFLOWER1.jpg": "595b",
	"./GAME_BEAUTIFULFLOWER2.jpg": "7898",
	"./GAME_BLOCKFLIP1.jpg": "4ffe",
	"./GAME_BLOCKFLIP2.jpg": "eb8f",
	"./GAME_BUNGEOPPANG.jpg": "9bcd",
	"./GAME_BUNGEOPPANG1.jpg": "44f1",
	"./GAME_BUNGEOPPANG2.jpg": "0ff7",
	"./GAME_BUTTERFLY.jpg": "7217",
	"./GAME_BUTTERFLY1.jpg": "5211",
	"./GAME_BUTTERFLY2.jpg": "2448",
	"./GAME_CARDPAIR.jpg": "f11d",
	"./GAME_CARDPAIR1.jpg": "08b7",
	"./GAME_CARDPAIR2.jpg": "4664",
	"./GAME_CARDRIVE1.jpg": "9a23",
	"./GAME_CARDRIVE2.jpg": "8bd2",
	"./GAME_CATCHTHEFISH.jpg": "ff58",
	"./GAME_CATCHTHEFISH1.jpg": "fd7e",
	"./GAME_CATCHTHEFISH2.jpg": "de18",
	"./GAME_CATCHTHEMOLE.jpg": "6601",
	"./GAME_CATCHTHEMOLE1.jpg": "964a",
	"./GAME_CATCHTHEMOLE2.jpg": "7242",
	"./GAME_COLORDRAW.jpg": "e066",
	"./GAME_COLORDRAW1.jpg": "e63e",
	"./GAME_COLORDRAW2.jpg": "c978",
	"./GAME_COLORLOTUS.jpg": "8a1b",
	"./GAME_COLORLOTUS1.jpg": "a593",
	"./GAME_COLORLOTUS2.jpg": "50e7",
	"./GAME_COLORPAPER.jpg": "e931",
	"./GAME_COLORPAPER1.jpg": "b461",
	"./GAME_COLORPAPER2.jpg": "baa6",
	"./GAME_COUNTCHICKS1.jpg": "d1d5",
	"./GAME_COUNTCHICKS2.jpg": "b462",
	"./GAME_CROSSTURTLE1.jpg": "e81c",
	"./GAME_CROSSTURTLE2.jpg": "6481",
	"./GAME_FINDSAMEPICTURE.jpg": "7845",
	"./GAME_FINDSAMEPICTURE1.jpg": "3625",
	"./GAME_FINDSAMEPICTURE2.jpg": "e51c",
	"./GAME_FLAG.jpg": "4d38",
	"./GAME_FLAG1.jpg": "60a2",
	"./GAME_FLAG2.jpg": "ed81",
	"./GAME_GETTHENUMBERDISH.jpg": "0426",
	"./GAME_GETTHENUMBERDISH1.jpg": "ab28",
	"./GAME_GETTHENUMBERDISH2.jpg": "31b4",
	"./GAME_GLACIER1.jpg": "2da7",
	"./GAME_GLACIER2.jpg": "5bd5",
	"./GAME_GOSTOP.jpg": "b2d3",
	"./GAME_GOSTOP1.jpg": "c072",
	"./GAME_GOSTOP2.jpg": "ae53",
	"./GAME_GUKHWAPPANG1.jpg": "41d8",
	"./GAME_GUKHWAPPANG2.jpg": "c961",
	"./GAME_HORSE.jpg": "eec4",
	"./GAME_HORSE1.jpg": "966d",
	"./GAME_HORSE2.jpg": "c8c5",
	"./GAME_LIGHTBUG1.jpg": "7b20",
	"./GAME_LIGHTBUG2.jpg": "3795",
	"./GAME_MINHWATU.jpg": "2a36",
	"./GAME_MINHWATU1.jpg": "f704",
	"./GAME_MINHWATU2.jpg": "f579",
	"./GAME_NIGHTSKY.jpg": "a6c7",
	"./GAME_NIGHTSKY1.jpg": "1ddb",
	"./GAME_NIGHTSKY2.jpg": "7708",
	"./GAME_NUMBER.jpg": "5e44",
	"./GAME_NUMBER1.jpg": "90e2",
	"./GAME_NUMBER2.jpg": "cf29",
	"./GAME_OILPAINT.jpg": "02ef",
	"./GAME_OILPAINT1.jpg": "8288",
	"./GAME_OILPAINT2.jpg": "950e",
	"./GAME_OXQUIZ.jpg": "2eb6",
	"./GAME_OXQUIZ1.jpg": "bc8f",
	"./GAME_OXQUIZ2.jpg": "adb9",
	"./GAME_PAINTBALL.jpg": "2a42",
	"./GAME_PAINTBALL1.jpg": "14fa",
	"./GAME_PAINTBALL2.jpg": "2ac2",
	"./GAME_PIANO.jpg": "2874",
	"./GAME_PIANO1.jpg": "6daf",
	"./GAME_PIANO2.jpg": "b3d8",
	"./GAME_PICTURELOTUS.jpg": "f514",
	"./GAME_PICTURELOTUS1.jpg": "6052",
	"./GAME_PICTURELOTUS2.jpg": "e78e",
	"./GAME_POND1.jpg": "b83a",
	"./GAME_POND2.jpg": "3930",
	"./GAME_QUIZ.jpg": "d228",
	"./GAME_QUIZ1.jpg": "4a91",
	"./GAME_QUIZ2.jpg": "5e45",
	"./GAME_RAINWINDOW.jpg": "f412",
	"./GAME_RAINWINDOW1.jpg": "5040",
	"./GAME_RAINWINDOW2.jpg": "17c3",
	"./GAME_SEAOFFANTASY.jpg": "ecde",
	"./GAME_SEAOFFANTASY1.jpg": "e9a7",
	"./GAME_SEAOFFANTASY2.jpg": "c3e5",
	"./GAME_SEAWORLD.jpg": "beb8",
	"./GAME_SEAWORLD1.jpg": "5e7f",
	"./GAME_SEAWORLD2.jpg": "d377",
	"./GAME_SOCCER.jpg": "4f3b",
	"./GAME_SOCCER1.jpg": "4dcc",
	"./GAME_SOCCER2.jpg": "ced7",
	"./GAME_SOUNDLINK1.jpg": "4118",
	"./GAME_SOUNDLINK2.jpg": "270a",
	"./GAME_SWEEPLEAVES1.jpg": "56a5",
	"./GAME_SWEEPLEAVES2.jpg": "0098",
	"./GAME_THREE.jpg": "90c9",
	"./GAME_THREE1.jpg": "225d",
	"./GAME_THREE2.jpg": "bebf",
	"./GAME_TRAIN.jpg": "cc02",
	"./GAME_TRAIN1.jpg": "2620",
	"./GAME_TRAIN2.jpg": "58a9",
	"./GAME_WORDFERRISWHEEL1.jpg": "80f5",
	"./GAME_WORDFERRISWHEEL2.jpg": "44ef",
	"./RECREATION_MATCHPICTURE.jpg": "1069",
	"./RECREATION_SAMEACTION.jpg": "f693",
	"./RECREATION_SPEEDQUIZ.jpg": "e5fb",
	"./RECREATION_YOURFEELING.jpg": "9130"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e38d";